
import React from 'react';

import { useReadAloud } from '../conquest/hooks/use-read-aloud';
import Activity from '../activity/activity';
import Header from '../header/header';
import StudentProgress from '../student-progress/student-progress';
import css from './mle.scss';

const HeaderAndActivity = () => {
  const { readAloudConfig, onLocaleChange } = useReadAloud();

  return (
    <React.Fragment>
      <Header onLocaleChange={onLocaleChange} />
      <div className={css.content}>
        <Activity readAloudConfig={readAloudConfig} />
        <StudentProgress />
      </div>
    </React.Fragment>
  );
};

export default HeaderAndActivity;
